import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { EventModel } from './event.model';
import { EventPlannerSupplierModel } from './event-planner-supplier.model';

@Injectable({
  providedIn: 'root',
})
export class EventPlannerSupplierService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getPlannerSuppliers(eventId: number | string): Observable<{ data: EventPlannerSupplierModel[] }> {
    return this.http.get<{ data: EventPlannerSupplierModel[] }>(`${this.apiUrl}/api/events/${eventId}/planner-suppliers`);
  }

  createPlannerSupplier(eventId: number | string, formData: FormData): Observable<ResourceData<EventPlannerSupplierModel>> {
    return this.http.post<ResourceData<EventPlannerSupplierModel>>(`${this.apiUrl}/api/events/${eventId}/planner-suppliers`, formData);
  }

  updatePlannerSupplier(eventId: number | string, supplierId: number, formData: FormData): Observable<ResourceData<EventPlannerSupplierModel>> {
    return this.http.post<ResourceData<EventPlannerSupplierModel>>(`${this.apiUrl}/api/events/${eventId}/planner-suppliers/${supplierId}`, formData);
  }

  deletePlannerSupplier(eventId: number | string, supplierId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/api/events/${eventId}/planner-suppliers/${supplierId}`);
  }

  updateSupplierNotes(eventId: number | string, supplier_notes: string | null): Observable<ResourceData<EventModel>> {
    return this.http.put<ResourceData<EventModel>>(`${this.apiUrl}/api/events/${eventId}/supplier-notes`, {
      supplier_notes,
    });
  }
}
